/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type verifyClaimerUserInput = {
    readonly clientMutationId: string;
    readonly email: string;
};
export type verifyClaimProfileUserMutationVariables = {
    readonly input: verifyClaimerUserInput;
};
export type verifyClaimProfileUserMutationResponse = {
    readonly verifyClaimProfileUser: {
        readonly errors: ReadonlyArray<{
            readonly id: string;
            readonly location: string | null;
        } | null> | null;
        readonly hasErrors: boolean | null;
    } | null;
};
export type verifyClaimProfileUserMutation = {
    readonly response: verifyClaimProfileUserMutationResponse;
    readonly variables: verifyClaimProfileUserMutationVariables;
};



/*
mutation verifyClaimProfileUserMutation(
  $input: verifyClaimerUserInput!
) {
  verifyClaimProfileUser(input: $input) {
    errors {
      id
      location
    }
    hasErrors
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "verifyClaimerUserInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "verifyClaimProfileUser",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "VerifyClaimerUserPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "errors",
        "storageKey": null,
        "args": null,
        "concreteType": "Error",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "location",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "hasErrors",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "verifyClaimProfileUserMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "verifyClaimProfileUserMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "verifyClaimProfileUserMutation",
    "id": null,
    "text": "mutation verifyClaimProfileUserMutation(\n  $input: verifyClaimerUserInput!\n) {\n  verifyClaimProfileUser(input: $input) {\n    errors {\n      id\n      location\n    }\n    hasErrors\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'bf57efc5d680682cdc3cf47fef862186';
export default node;
